<template>
  <svg xmlns="http://www.w3.org/2000/svg" :width="width" :height="height" viewBox="0 0 111.628 111.628">
    <path id="Very_Good" data-name="Very Good"
      d="M2685.96,0a55.814,55.814,0,1,0,55.814,55.814A55.877,55.877,0,0,0,2685.96,0m11.268,41.738a7.638,7.638,0,0,1,6.874-6.643,7.723,7.723,0,0,1,8.35,9.211,1.192,1.192,0,0,1-1.167.957h0a3.525,3.525,0,0,1-1.953-.591l-2.566-1.708a3.4,3.4,0,0,0-3.766,0l-2.566,1.708a3.525,3.525,0,0,1-1.954.591,1.188,1.188,0,0,1-1.166-.947,7.759,7.759,0,0,1-.085-2.578m-37.843,0a7.638,7.638,0,0,1,6.874-6.643,7.724,7.724,0,0,1,8.35,9.211,1.192,1.192,0,0,1-1.167.957h0a3.524,3.524,0,0,1-1.953-.591l-2.566-1.708a3.4,3.4,0,0,0-3.766,0l-2.566,1.708a3.526,3.526,0,0,1-1.953.591,1.187,1.187,0,0,1-1.166-.947,7.766,7.766,0,0,1-.085-2.578m53.6,19.984a27.86,27.86,0,0,1-54.057,0,2.68,2.68,0,0,1,5.2-1.3,22.5,22.5,0,0,0,43.656,0,2.68,2.68,0,0,1,5.2,1.3"
      transform="translate(-2630.146)" :fill="themeColor" />
  </svg>
</template>

<script>
import { mapWritableState } from 'pinia';
import { useChatSettingsStore } from '../../../../store/ChatSettingsStore/ChatSettingsStore';

export default {
  props: {
    themeColor: {
      type: String,
      required: false,
      default: '#B3B3B3',
    },
    isHoverUser: {
      type: Boolean,
      required: false,
      default: false,
    },
    height: {
      type: String,
      required: false,
      default: '50px',
    },
    width: {
      type: String,
      required: false,
      default: '100px',
    },
  },
  data() {
    return {
      themePrimaryColor: window.primaryColor,
    }
  },
  computed: {
    ...mapWritableState(useChatSettingsStore, ['chatThemeSettings']),
  },
}
</script>
